import { gql } from '@apollo/client';

const SCHEDULE_ORDER_UNLOCK_MASTERCODE = gql`
  mutation scheduleUnlockOrderMastercodes($orderId: Int!, $date: DateTime!) {
    scheduleUnlockOrderMastercodes(where: { id: $orderId }, date: $date) {
      count
    }
  }
`;

export default SCHEDULE_ORDER_UNLOCK_MASTERCODE;
